module.exports = __webpack_public_path__ + "img/logo.111db51e.png";